// Modified by Sullivan Digital, 2026-10-26: the login page footer carries the SALDP white-labelling AGPL "Source code" link. Licensed under the GNU AGPL v3.
import type { ReactNode } from "react";

import { LighthouseIllustration } from "metabase/common/components/LighthouseIllustration";
import { LogoIcon } from "metabase/common/components/LogoIcon";
import { useSelector } from "metabase/redux";
import { SourceCodeLink } from "metabase/saldp-branding/components/SourceCodeLink/SourceCodeLink";
import { getLoginPageIllustration } from "metabase/selectors/whitelabel";
import { Text } from "metabase/ui";

import {
  LayoutBody,
  LayoutCard,
  LayoutIllustration,
  LayoutRoot,
} from "./AuthLayout.styled";
interface AuthLayoutProps {
  children?: ReactNode;
}

export const AuthLayout = ({ children }: AuthLayoutProps): JSX.Element => {
  const loginPageIllustration = useSelector(getLoginPageIllustration);

  return (
    <LayoutRoot data-testid="login-page">
      {loginPageIllustration &&
        (loginPageIllustration.isDefault ? (
          <LighthouseIllustration />
        ) : (
          <LayoutIllustration
            data-testid="login-page-illustration"
            backgroundImageSrc={loginPageIllustration.src}
          />
        ))}
      <LayoutBody>
        <LogoIcon height={65} />
        <LayoutCard>{children}</LayoutCard>
        <Text component="footer" mt="lg" size="sm" data-testid="login-footer">
          <SourceCodeLink />
        </Text>
      </LayoutBody>
    </LayoutRoot>
  );
};
